module.exports = __webpack_public_path__ + "img/view-insights.10dcfb6e.svg";